// extracted by mini-css-extract-plugin
module.exports = {"page-404":"nomatchpage_page-404__2bcHf","page-404__m":"nomatchpage_page-404__m__eT3lA","page-404__text":"nomatchpage_page-404__text__f2Hs-"};